/**
 * Converts the first character of a string to uppercase.
 *
 * @param str - The string to convert.
 * @returns The string with the first character in uppercase.
 */
export function ucfirst(str: string): string {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
